exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cardContainer{\r\n  padding: 10px;\r\n  color: #eeeeee;\r\n}\r\n.header{\r\n  padding: 5px;\r\n  text-align: center;\r\n  font-size: 1.6em;\r\n}\r\n.card {\r\n  /* Add shadows to create the \"card\" effect */\r\n  font-family: \"Roboto\", \"Trebuchet MS\", Arial, Helvetica, sans-serif;\r\n  border-radius: 5px;\r\n  font-weight: bold;\r\n  background: #3f51b5;\r\n  margin-top: 10px;\r\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\r\n  transition: 0.3s;\r\n}\r\n\r\n.cardDetail {\r\n  /* Add shadows to create the \"card\" effect */\r\n  font-family: \"Roboto\", \"Trebuchet MS\", Arial, Helvetica, sans-serif;\r\n  border-radius: 5px;\r\n  font-size: 1.2em;\r\n  font-weight: bold;\r\n  margin-top: 10px;\r\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\r\n  transition: 0.3s;\r\n  height: auto;\r\n}\r\n\r\n/* On mouse-over, add a deeper shadow */\r\n.card:hover {\r\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\r\n}\r\n\r\n/* Add some padding inside the card container */\r\n.container {\r\n  padding: 5px 16px;\r\n  width: 100%;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/inicio/inicio.component.css
// module id = ../../../../../src/app/inicio/inicio.component.css
// module chunks = 0